import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./components/AuthProvider";
import { AppShell } from "./components/AppShell";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LoginPage } from "./pages/LoginPage";
import { ChangePasswordPage } from "./pages/ChangePasswordPage";
import { DashboardPage } from "./pages/DashboardPage";
import { UsersPage } from "./pages/UsersPage";
import { UserDetailPage } from "./pages/UserDetailPage";
import { CoursesPage } from "./pages/CoursesPage";
import { MyCoursesPage } from "./pages/MyCoursesPage";
import { CourseDetailPage } from "./pages/CourseDetailPage";
import { ModuleDetailPage } from "./pages/ModuleDetailPage";
import { LessonEditPage } from "./pages/LessonEditPage";
import { StudentCoursePage } from "./pages/StudentCoursePage";
import { StudentModulePage } from "./pages/StudentModulePage";
import { StudentProfilePage } from "./pages/StudentProfilePage";
import { StudentLessonPage } from "./pages/StudentLessonPage";
import { QuizListPage } from "./pages/QuizListPage";
import { QuizEditorPage } from "./pages/QuizEditorPage";
import { StudentQuizPage } from "./pages/StudentQuizPage";
import { KnowledgePage } from "./pages/KnowledgePage";
import { ArticlePage } from "./pages/ArticlePage";
import { ArticleEditPage } from "./pages/ArticleEditPage";
import { AnalyticsPage } from "./pages/AnalyticsPage";
import { AuditLogPage } from "./pages/AuditLogPage";

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppShell>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute>
                <ChangePasswordPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/:userId"
            element={
              <ProtectedRoute>
                <UserDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses"
            element={
              <ProtectedRoute>
                <CoursesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-courses"
            element={
              <ProtectedRoute>
                <MyCoursesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/courses/:courseId"
            element={
              <ProtectedRoute>
                <CourseDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/modules/:moduleId"
            element={
              <ProtectedRoute>
                <ModuleDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/lessons/:lessonId"
            element={
              <ProtectedRoute>
                <LessonEditPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learn/courses/:courseId"
            element={
              <ProtectedRoute>
                <StudentCoursePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learn/modules/:moduleId"
            element={
              <ProtectedRoute>
                <StudentModulePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <StudentProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learn/lessons/:lessonId"
            element={
              <ProtectedRoute>
                <StudentLessonPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quizzes"
            element={
              <ProtectedRoute>
                <QuizListPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/quizzes/:quizId"
            element={
              <ProtectedRoute>
                <QuizEditorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learn/quizzes/:quizId"
            element={
              <ProtectedRoute>
                <StudentQuizPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kb"
            element={
              <ProtectedRoute>
                <KnowledgePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kb/articles/new"
            element={
              <ProtectedRoute>
                <ArticleEditPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kb/articles/:articleId/edit"
            element={
              <ProtectedRoute>
                <ArticleEditPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kb/articles/:articleId"
            element={
              <ProtectedRoute>
                <ArticlePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <AnalyticsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/audit"
            element={
              <ProtectedRoute>
                <AuditLogPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </AppShell>
      </AuthProvider>
    </BrowserRouter>
  );
}
